import React from 'react'
import NavBar from '../Components/Navb'
import Footer from '../Components/Footer'
import { Center,Box } from '@chakra-ui/react'

function ScholarshipPage() {
  return (<>
   <NavBar/>
    <div fontFamily="Arvo">
     <h1> <Center fontFamily={"cursive"} my={"10px"} color={"yellow.400"}>SBPathsala's Scholarship Program</Center></h1>
     <Box m="10px" boxShadow= '10px 10px 10px 0px rgba(0, 0, 0, 0.75)' border='1px' borderColor='gray.200' p="20px" borderRadius={"10px"}>
   <h4 style={{color:'blue'}}> Empowering Dreams: SBPathsala Coaching Center's Scholarship Initiative for Deserving Students</h4>

   <strong>In a world where educational aspirations face financial hurdles, SBPathsala Coaching Center emerges as a guiding light. Their recently initiated scholarship program, designed to ensure equal opportunities for all, has become a beacon of hope, transcending monetary limitations.

At the heart of this initiative is the Scholarship Test, a unique opportunity for individuals with immense potential, regardless of their financial standing. SBPathsala believes in the universal right to quality education, emphasizing that everyone, irrespective of their background, deserves a chance to learn and grow.

Going beyond financial aid, the scholarship program is a commitment to nurturing talent. Successful candidates not only receive financial support but also benefit from additional resources such as study materials, mentorship, and exclusive programs, ensuring a holistic approach to academic success.

The primary goal of the scholarship program is to empower talented individuals from diverse backgrounds. SBPathsala firmly asserts that education is a fundamental right and strives to eliminate barriers, providing opportunities for all to learn and succeed.

As scholarship recipients progress in their educational journey, they become inspirations within their communities. SBPathsala's commitment extends beyond traditional teaching, offering comprehensive support from counseling services to career guidance. Collaborating with local groups ensures the program's broad reach to as many deserving students as possible.
</strong>
  <h4 style={{color:'blue'}}>In addition to the scholarship program's details,</h4>
  <h5 style={{fontFamily:"Arvo"}}>Scholarship Details</h5>
  <h4 fontFamily={"cursive"}>250-Fee Category:</h4>
    <ul>
        <li><strong>Fee Structure:</strong> Candidates in this category are required to pay a nominal registration fee of
            250.</li>
        <li><strong>Benefits:</strong> The top 50 students from this category, upon successfully cracking the scholarship
            exam, will be granted a 30% waiver on their course fees. Additionally, they will receive complimentary
            meals.</li>
    </ul>

    <h4>1000-Fee Category:</h4>
    <ul>
        <li><strong>Fee Structure:</strong> Applicants in this category will need to pay a registration fee of 1000.</li>
        <li><strong>Benefits:</strong> The top 30 students from this category, upon successfully cracking the scholarship
            exam, will enjoy a 100% waiver on their course fees. In addition, they will receive free hostel accommodation
            and complimentary meals.</li>
    </ul>

    <h2>Selection Process:</h2>
    <p>The scholarship recipients will be chosen through a rigorous test that assesses their academic proficiency,
        problem-solving skills, and critical thinking abilities. This comprehensive evaluation aims to identify
        individuals who not only excel academically but also demonstrate potential and passion in their chosen
        fields.</p>

    <h2 style={{color:'red'}}>Course Fee Waivers</h2>

    <h3 style={{fontFamily:'Arvo',color:'green'}}>250-Fee Category:</h3>
    <p style={{fontWeight:'bold'}}>The top 50 students in this category, upon successfully cracking the scholarship exam, will benefit from a 30%
        waiver on their course fees, alleviating the financial burden on their educational journey.</p>

    <h3 style={{fontFamily:'Arvo',color:'green'}}>1000-Fee Category:</h3>
    <p style={{fontWeight:'bold'}}>The top 30 students in this category, upon successfully cracking the scholarship exam, will receive a 100% waiver
        on their course fees, significantly reducing the overall cost of their education.</p>

    <h3 style={{fontFamily:'Arvo',color:'green'}}>Free Course, Hostel</h3>
    <p style={{fontWeight:'bold'}}>For the top 30 students in the 1000-Fee Category, the scholarship includes not only a 100% waiver on course fees
        but also free hostel accommodation, ensuring a conducive and supportive environment for
        their academic pursuits.</p>

    <h5 style={{color:'green'}}>Celebrating Success</h5>
    <p style={{fontWeight:'bold'}}>Upon successfully cracking the scholarship exam and securing their spots, we joyfully celebrate the success of
        these talented individuals. This marks the beginning of a transformative journey, and we extend our heartfelt
        congratulations to the selected candidates. Best of luck as you embark on this exciting chapter of your academic
        journey!</p>
  <Box boxShadow= '10px 10px 10px 0px rgba(0, 0, 0, 0.75)'> </Box>
   <Box></Box>

<Center fontFamily={"fantasy"} mx="10px">In conclusion, SBPathsala's scholarship program is a source of hope, striving for a future where the power of education reaches everyone, regardless of their background.
</Center>





</Box>
    </div>

    <Footer/>
  </>
  )
}

export default ScholarshipPage